import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ErrorComponent } from './error/error.component';
import { InformationComponent } from './information/information.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HelpComponent } from './help/help.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ObjectDialogComponent } from './object-dialog/object-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ComponentsModule } from '../../../components/src/lib/components.module';
import { ButtonComponent, IconsComponent } from 'libs/migo-uikit-v4/src';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatSnackBarModule,
    NgxJsonViewerModule,
    MatProgressBarModule,
    ComponentsModule,
    ButtonComponent,
    IconsComponent,
    TranslateModule
  ],
  declarations: [
    ConfirmationComponent,
    ErrorComponent,
    InformationComponent,
    HelpComponent,
    ObjectDialogComponent,
  ],
  exports: [
    ConfirmationComponent,
    ErrorComponent,
    InformationComponent,
    HelpComponent,
    ObjectDialogComponent,
  ],
})
export class DialogsModule {}
